export default "__VITE_ASSET__CxmWHX_Q__"